import { IconButton, Stack } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import NotificationRow from '@/components/wrapped/NotificationRow';
import { type CamNotification } from '@/cam-admin/notifications/Notifications.fixtures';

// A stack of notification rows for one date chunk. Owns the per-row wiring: the
// "Caring for {customer}" body line and the envelope toggle. Composes the shared
// NotificationRow.
const NotificationStack = ({
  items,
  onOpen,
  onToggleRead,
}: {
  items: CamNotification[];
  onOpen: (n: CamNotification) => void;
  onToggleRead: (n: CamNotification) => void;
}) => (
  <Stack spacing={1.5}>
    {items.map((n) => {
      return (
        <NotificationRow
          key={n.id}
          title={n.title}
          body={`Caring for ${n.customer}`}
          when={n.when}
          read={n.read}
          onOpen={() => onOpen(n)}
          trailing={
            <IconButton
              aria-label={n.read ? 'Mark as unread' : 'Mark as read'}
              size='small'
              onClick={() => onToggleRead(n)}
            >
              <Icon
                icon={(n.read ? 'envelope-open' : 'envelope') as never}
                fontSize={18}
              />
            </IconButton>
          }
        />
      );
    })}
  </Stack>
);

export default NotificationStack;
